<template>
    <b-modal v-model="localIsVisible" size="xl" hide-footer
        :title="prefix + ' > ' + title" @hidden="handleClose">
        
        <RegistroEntradaList :empenho="empenho" :contrato="contrato" :podeAdicionarRegistro="podeAdicionarRegistro" :idAutorizacao="idAutorizacao" />
    </b-modal>
</template>

<script>
import RegistroEntradaList from "./RegistroEntradaList.vue"

export default {
    components: {
        RegistroEntradaList
    },
    props: {
        empenho:{
            type:Object,
            default: null,
        },
        contrato:{
            type:Object,
            default:null
        },
        podeAdicionarRegistro:{
            type:Boolean,
            default: true
        },
        idAutorizacao: {
            type: Number,
            default: null
        },

        isVisible: {
            type: Boolean,
            default: false
        },
        prefix: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: "Registro de Entrada"
        }
    },
    methods: {
        handleClose() {
            this.$emit('close');
        }
    },
     data() {
        return {
           localIsVisible: true
        }
    }

};
</script>
